<ui-dialog
    size="small"
    [open]="isUnableToSponsorJobModalOpen"
    header="{{ 'applicant-tracker.unableToSponsorJob' | translate }}"
    (closing)="isUnableToSponsorJobModalOpen = false"
>
    <p [innerHTML]="'applicant-tracker.messages.jobPosting.indeedPaymentDetailsAreMissing' | translate"></p>
    <ui-dialog-footer>
        <ui-button type="primary" (click)="closeUnableSponsorJobDialog()">{{
            'applicant-tracker.okay' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isOpenRemoveIntegration"
    header="applicant-tracker.removeFromJobBoardDialog.removeToJobBoardJobTitle"
    (closing)="closeRemoveIntegrationModal()"
>
    <p
        [innerHTML]="
            'applicant-tracker.removeFromJobBoardDialog.remove'
                | translate
                    : {
                          integrationText: integrationDialogText,
                      }
                | sanitizeHtml
        "
    ></p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeRemoveIntegrationModal()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="danger" (click)="onRemoveJobIntegration()" [disabled]="isLoading">{{
            'remove' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isOpenAddIntegration"
    header="applicant-tracker.removeFromJobBoardDialog.header"
    (closing)="closeAddIntegrationModal()"
>
    <p
        [innerHTML]="
            'applicant-tracker.removeFromJobBoardDialog.add'
                | translate
                    : {
                          integrationText: integrationDialogText,
                      }
                | sanitizeHtml
        "
    ></p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeAddIntegrationModal()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onAddJobIntegration()" [disabled]="isLoading">{{
            'add' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isIndeedValidationModalOpen"
    (closing)="isIndeedValidationModalOpen = false"
    header="applicant-tracker.unableToPostToIndeedDialog.header"
>
    <p>{{ 'applicant-tracker.unableToPostToIndeedDialog.errorMessageInfo' | translate }}</p>

    <ul *ngFor="let violation of indeedValidationMessages">
        <li>{{ violation.field }}: {{ violation.message }}</li>
    </ul>

    <p>{{ 'applicant-tracker.unableToPostToIndeedDialog.tryAgain' | translate }}</p>

    <ui-dialog-footer>
        <ui-button type="primary" (click)="onCancelIndeedIntegration()">{{
            'applicant-tracker.okay' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isIndeedValidationUpdateModalOpen"
    (closing)="onClosingIndeedValidationUpdateModal()"
    header="applicant-tracker.unableToUpdateToIndeedDialog.header"
>
    <p>{{ 'applicant-tracker.unableToUpdateToIndeedDialog.errorMessageInfo' | translate }}</p>

    <ul *ngFor="let violation of indeedValidationMessages">
        <li>{{ violation.field }}: <span [innerHTML]="violation.message | sanitizeHtml"></span></li>
    </ul>

    <p [innerHTML]="'applicant-tracker.unableToUpdateToIndeedDialog.areYouSure' | translate"></p>

    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onClosingIndeedValidationUpdateModal()">
            {{ 'cancel' | translate }}
        </ui-button>
        <ui-button type="primary" (click)="onProceed()">{{ 'applicant-tracker.confirm' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<!--Body-->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-job-posting-header
        [jobPosting]="jobPosting"
        (onChangePause)="onPause($event)"
        (onArchiveChange)="onArchiveChange($event)"
    ></app-job-posting-header>

    <div class="ui layout">
        <div class="content">
            <div class="ui stackable grid" *ngIf="jobPosting">
                <div class="twelve wide column">
                    <ui-card role="group" aria-labelledby="job-posting-info-header">
                        <ng-container *ngIf="!isEditingPostingInformation">
                            <ui-button
                                *ngIf="canEditJobPosting"
                                type="link"
                                style="float: right"
                                (click)="isEditingPostingInformation = true"
                                class="edit"
                                >{{ 'edit' | translate }}</ui-button
                            >
                            <app-segment-header
                                id="job-posting-info-header"
                                title="applicant-tracker.jobPostingInformation"
                            ></app-segment-header>

                            <!--Posting information goes here-->
                            <div class="ui form">
                                <div class="app-grid">
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.jobTitle' | translate }}</label>
                                        {{ jobPosting.title }}
                                    </div>
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.status' | translate }}</label>
                                        <ui-badge
                                            *ngIf="!jobPosting.archivedAt && !jobPosting.pausedAt"
                                            type="success"
                                            >{{ 'applicant-tracker.active' | translate }}</ui-badge
                                        >
                                        <ui-badge *ngIf="jobPosting.archivedAt" type="alert">{{
                                            'applicant-tracker.statuses.archived' | translate
                                        }}</ui-badge>
                                        <ui-badge
                                            *ngIf="!jobPosting.archivedAt && jobPosting.pausedAt"
                                            type="warning"
                                            >{{ 'applicant-tracker.paused' | translate }}</ui-badge
                                        >
                                    </div>
                                </div>
                                <div class="app-grid">
                                    <div class="field columns-6" data-cy="locationTypeInfo">
                                        <label>{{
                                            'forms.applicant-tracker.locationTypeTitleLabel' | translate
                                        }}</label>
                                        {{ this.jobPosting.jobPostingLocationType.label | translate }}
                                    </div>
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.streetAddress' | translate }}</label>
                                        <app-address-link
                                            *ngIf="jobPostingFullLocation"
                                            [fullLocation]="jobPostingFullLocation"
                                        ></app-address-link>
                                    </div>
                                </div>
                                <div class="app-grid">
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.unitSuite' | translate }}</label>
                                        {{ jobPosting.addressLine2 }}
                                    </div>
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.city' | translate }}</label>
                                        {{ jobPosting.city }}
                                    </div>
                                </div>
                                <div class="app-grid">
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.provinceState' | translate }}</label>
                                        {{ jobPosting.region }}
                                    </div>
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.postalZipCode' | translate }}</label>
                                        {{ jobPosting.postalCode }}
                                    </div>
                                </div>
                                <div class="app-grid">
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.country' | translate }}</label>
                                        {{ jobPosting.country }}
                                    </div>
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.jobType' | translate }}</label>
                                        {{ jobPosting.level | appTranslateOptions: employmentTypeDisplay | titlecase }}
                                    </div>
                                </div>
                                <div class="app-grid">
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.jobCategory' | translate }}</label>
                                        {{ jobPosting.category }}
                                    </div>
                                    <div class="field columns-6" data-testid="compensationTypeInfo">
                                        <label>{{ 'forms.applicant-tracker.compensation' | translate }}</label>
                                        {{ jobPosting.payLow }}
                                        <span *ngIf="jobPosting.payLow && jobPosting.payHigh">
                                            {{ 'applicant-tracker.components.job-posting.to' | translate }}
                                        </span>
                                        {{ jobPosting.payHigh }}
                                        <span
                                            *ngIf="
                                                jobPosting.compensationType && (jobPosting.payLow || jobPosting.payHigh)
                                            "
                                        >
                                            {{ 'forms.applicant-tracker.reviewSection.per' | translate }}
                                            {{ jobPosting.compensationTypeAsNoun }}
                                        </span>
                                    </div>
                                </div>
                                <div class="app-grid">
                                    <div class="field columns-6">
                                        <label>{{ 'applicant-tracker.postingLink' | translate }}</label>
                                        <a (click)="goToPostingLink(jobPosting.jobBoardLink(jobBoardSettings))">
                                            {{ jobPosting.jobBoardLink(jobBoardSettings) }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="isEditingPostingInformation">
                            <ui-button
                                [disabled]="!jobPosting.isDirty()"
                                type="primary"
                                style="float: right"
                                (click)="onSave()"
                                >{{ 'save' | translate }}</ui-button
                            >
                            <ui-button type="ghost" class="margin-right-2" style="float: right" (click)="onCancel()">{{
                                'cancel' | translate
                            }}</ui-button>
                            <app-segment-header
                                id="job-posting-info-header"
                                title="{{ 'applicant-tracker.jobPostingInformation' | translate }}"
                            ></app-segment-header>

                            <app-job-posting-update-basic-information #jobInformationForm [jobPosting]="jobPosting">
                            </app-job-posting-update-basic-information>
                        </ng-container>
                    </ui-card>
                    <div class="margin-bottom-3">
                        @if (jobBoardIntegrationsCardV2) {
                            <app-job-board-integrations-v2 [jobPosting]="jobPosting"></app-job-board-integrations-v2>
                        } @else {
                            <app-job-board-integrations
                                [integration]="indeedIntegration"
                                [jobIntegration]="jobIntegration"
                                [jobIndeedIntegration]="jobIndeedIntegration"
                                [jobPosting]="jobPosting"
                                [indeedPublicUrl]="indeedPublicUrl"
                                [isSyncing]="isIndeedSyncing"
                                [isFailed]="isIndeedFailed"
                                (integrationChange)="onIndeedIntegrationToggleChange($event)"
                                (loading)="isLoading = $event"
                                (invalidBillingState)="isUnableToSponsorJobModalOpen = true"
                            ></app-job-board-integrations>
                        }
                    </div>
                    <div class="ui segment">
                        <ng-container *ngIf="!isEditingJobDescription">
                            <ui-button
                                *ngIf="canEditJobPosting"
                                type="link"
                                style="float: right"
                                (click)="isEditingJobDescription = true"
                                class="edit"
                                >{{ 'edit' | translate }}</ui-button
                            >
                        </ng-container>
                        <ng-container *ngIf="isEditingJobDescription">
                            <ui-button type="primary" style="float: right" (click)="onSaveJobDescription()">{{
                                'save' | translate
                            }}</ui-button>
                            <ui-button type="ghost" class="margin-right-2" style="float: right" (click)="onCancel()">{{
                                'cancel' | translate
                            }}</ui-button>
                        </ng-container>
                        <app-segment-header
                            [class.remove-margin-bottom]="isEditingJobDescription"
                            title="applicant-tracker.jobDescription"
                        ></app-segment-header>

                        <ng-container *ngIf="!isEditingJobDescription">
                            <div class="job-description-container">
                                <div
                                    [innerHTML]="jobPosting.description | nl2br | sanitizeHtml"
                                    class="ui segment job-description-section-text ql-editor"
                                ></div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="isEditingJobDescription">
                            <app-job-posting-update-description-information
                                #descriptionForm
                                [jobPosting]="jobPosting"
                            ></app-job-posting-update-description-information>
                        </ng-container>
                    </div>
                </div>
                <div class="four wide column">
                    <div class="ui segment">
                        <app-hiring-team-list [assignments]="jobPosting.managerAssignments"> </app-hiring-team-list>
                    </div>
                    <div class="ui segment">
                        <app-segment-header title="applicant-tracker.notifications"></app-segment-header>
                        <div class="flex grid">
                            <span id="notify-toggle-label">{{ 'applicant-tracker.notifyEmpty' | translate }}</span>
                            <mat-slide-toggle
                                name="subscribeToggle"
                                color="primary"
                                aria-labelledby="notify-toggle-label"
                                [(ngModel)]="isSubscribedToJobPosting"
                                (ngModelChange)="saveSubscriptionStatus($event)"
                            ></mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
